import React from 'react';
import { tA11y } from '@lwtears/lwt-common-frontend/lib/@common/util/i18n-util';
import { Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import useProgress from '../../hooks/use-progress';
import { FONT_GSS_FUTURA_SEMI_BOLD } from '@monorepo/shared/src/themes/defaultTheme';

type FindItActivityProgressProps = {
  activityType: string;
};

const FindItActivityProgress: React.FC<FindItActivityProgressProps> = ({ activityType }) => {
  const [{ currentTotal: total, currentFound: found }] = useProgress();

  const entityName = tA11y(`activities.FindIt.${activityType}`);
  const classes = useStyles();

  return (
    <Typography className={classes.text} align="center">
      {tA11y('activities.FindIt.footer', {
        element: entityName,
        found,
        total,
      })}
    </Typography>
  );
};

const useStyles = makeStyles((theme) => ({
  text: {
    fontFamily: FONT_GSS_FUTURA_SEMI_BOLD,
    fontSize: theme.typography.pxToRem(28),
    lineHeight: theme.typography.pxToRem(60),
    whiteSpace: 'nowrap',
  },
}));

export default FindItActivityProgress;
